import { render, staticRenderFns } from "./weekly.vue?vue&type=template&id=1877e5e0&scoped=true"
import script from "./weekly.vue?vue&type=script&lang=js"
export * from "./weekly.vue?vue&type=script&lang=js"
import style0 from "./weekly.vue?vue&type=style&index=0&id=1877e5e0&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1877e5e0",
  null
  
)

export default component.exports